var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlay = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8546 53.0217C20.1877 58.2502 26.5142 60.8645 33.8341 60.8645C41.1541 60.8645 47.4283 58.2502 52.6568 53.0217C57.99 47.6886 60.6565 41.3621 60.6565 34.0421C60.6565 26.7222 57.99 20.448 52.6568 15.2194C47.4283 9.88634 41.1541 7.21978 33.8341 7.21978C26.5142 7.21978 20.1877 9.88634 14.8546 15.2194C9.62604 20.448 7.01178 26.7222 7.01178 34.0421C7.01178 41.3621 9.62604 47.6886 14.8546 53.0217ZM10.1489 10.5138C16.7368 3.92581 24.6319 0.631836 33.8341 0.631836C43.0364 0.631836 50.8792 3.92581 57.3625 10.5138C63.9505 16.9971 67.2445 24.8399 67.2445 34.0421C67.2445 43.2444 63.9505 51.1394 57.3625 57.7274C50.8792 64.2108 43.0364 67.4525 33.8341 67.4525C24.6319 67.4525 16.7368 64.2108 10.1489 57.7274C3.66552 51.1394 0.423828 43.2444 0.423828 34.0421C0.423828 24.8399 3.66552 16.9971 10.1489 10.5138ZM27.0893 49.1003V18.984L47.1669 34.0421L27.0893 49.1003Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlay, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/play.c73cf36a.svg";
export { ForwardRef as ReactComponent };